var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-fix-6759788",
    d: "M135.864,121.329l-1.2-1.2a.387.387,0,0,0-.56,0l-14,14a.387.387,0,0,0,0,.56l1.2,1.2a.4.4,0,0,0,.28.12.392.392,0,0,0,.28-.12l14-14A.386.386,0,0,0,135.864,121.329Zm-14.279,13.72-.64-.64,11.039-11.04.64.64Zm11.6-11.6-.64-.64,1.84-1.84.64.64Zm-8.8-1.04a1.2,1.2,0,0,1,1.2,1.2.4.4,0,1,0,.8,0,1.2,1.2,0,0,1,1.2-1.2.4.4,0,0,0,0-.8,1.2,1.2,0,0,1-1.2-1.2.4.4,0,1,0-.8,0,1.2,1.2,0,0,1-1.2,1.2.4.4,0,0,0,0,.8Zm1.6-.8a1.9,1.9,0,0,0,.4.4,1.9,1.9,0,0,0-.4.4,1.9,1.9,0,0,0-.4-.4A1.9,1.9,0,0,0,125.984,121.609Zm9.6,8a1.2,1.2,0,0,1-1.2-1.2.4.4,0,1,0-.8,0,1.2,1.2,0,0,1-1.2,1.2.4.4,0,0,0,0,.8,1.2,1.2,0,0,1,1.2,1.2.4.4,0,1,0,.8,0,1.2,1.2,0,0,1,1.2-1.2.4.4,0,0,0,0-.8Zm-1.6.8a1.9,1.9,0,0,0-.4-.4,1.9,1.9,0,0,0,.4-.4,1.9,1.9,0,0,0,.4.4A1.9,1.9,0,0,0,133.984,130.409Z",
    transform: "translate(-119.984 -120.009)",
    fill: "#038de3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagic);
export default __webpack_public_path__ + "static/media/magic.53848166b700f5ef7fea4328c61d116b.svg";
export { ForwardRef as ReactComponent };